export function Loading() {
    return (
        <div
            className="d-flex justify-content-center"
            role="status"
            aria-live="polite"
            aria-label="Loading content"
        >
            <div className="isloading" aria-hidden="true"></div>
            <span className="visually-hidden">Loading...</span>
        </div>
    )
}
